import { requireOptionalNativeModule } from 'expo';
import { Platform } from 'react-native';

import { SECURE_STORE_KEYS } from '@/constants/api';
import { secureStore } from '@/lib/secureStore';

/**
 * Asks for an App Store review the first time this phone cashes out. iOS
 * decides whether the sheet actually shows (at most 3 times a year).
 *
 * expo-store-review is only in the 0.1.2 build onward, and older binaries get
 * this same bundle by OTA. Importing the module there throws, so check for the
 * native side first and load it lazily. Never throws: a review prompt must not
 * get in the way of a cash-out.
 */
export async function requestReviewOnce(): Promise<void> {
  if (Platform.OS !== 'ios') return;
  if (!requireOptionalNativeModule('ExpoStoreReview')) return;
  try {
    if (await secureStore.get(SECURE_STORE_KEYS.reviewRequested)) return;
    const StoreReview = await import('expo-store-review');
    await StoreReview.requestReview();
    await secureStore.set(SECURE_STORE_KEYS.reviewRequested, '1');
  } catch {
    // Best effort; the cash-out carries on either way.
  }
}
